import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import * as g from 'src/app/globals';
import { Documents } from '@app/models/business/documents';
import { SessionStorageService } from './session-storage-service.service';

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private nzI18nService: NzI18nService,
    private sessionStorageService: SessionStorageService,
  ) {}

  init(fromOneTime, appKey?: string) {
    return new Promise<void>((resolve) => {
      this.http
        .get('/config.json')
        //.toPromise()
        .subscribe((config: any) => {
          console.log('subscribe((config: any)');

          if (!config.BaseUrl.endsWith('/')) {
            config.BaseUrl += '/';
          }

          g.setTokenInCookie(config.TokenInCookie);
          g.setDisplayOpenedObjectHistory(config.DisplayOpenedObjectHistory);
          g.setExternalPortalProfileModuleId(
            config.ExternalPortalProfileModuleId,
          );
          g.setDisplayCartProductsAsCardsByDefault(
            config.DisplayCartProductsAsCardsByDefault,
          );
          g.setShoppingCartEnableCategoryFirstBrowsing(
            config.ShoppingCartEnableCategoryFirstBrowsing,
          );
          g.setApiBaseUrl(config.BaseUrl + 'api/');
          g.setEmailsServiceUrl(config.EmailsServiceUrl);
          g.setEmailsServiceCreds(config.EmailsServiceCreds);
          g.setBaseUrl(config.BaseUrl);
          g.setLocale(config.Locale);
          g.setRedirectToExternalLogin(config.RedirectToExternalLogin);
          g.setgrossPriceChangeResetDiscount(
            config.GrossPriceChangeResetDiscount,
          );
          g.setfilterFormatDate(config.FilterDateFormat);
          g.setMultiOptionsSeparator(config.MultiOptionsSeparator);
          g.setAllowClearDate(config.AllowClearDate);
          g.setPageSizeInLineSection(config.PageSizeInLineSection);
          g.setBD_FilterSectionID(config.BD_FilterSectionID);
          g.setBD_TableSectionID(config.BD_TableSectionID);
          g.setBD_DocumentQryID(config.BD_DocumentQryID);
          g.setEnablePaginationInLineSection(
            config.EnablePaginationInLineSection,
          );
          g.setHideLinesWithZeroQtyForDocs(config.HideLinesWithZeroQtyForDocs);
          g.setBomComponentVisibilityByModule(
            config.BomComponentVisibilityByModule,
          );
          g.setLineReadonlyModeByModule(config.LineReadonlyModeByModule);
          g.setEnableSearchOnPartForObject(config.EnableSearchOnPartForObject);
          g.setLengthForSearchOnPart(config.LengthForSearchOnPart);
          g.setAutoSubmitSaveDraftForModules(
            config.AutoSubmitSaveDraftForModules,
          );
          g.setAutoRefreshListForModules(config.AutoRefreshListForModules);
          g.setAutoRefreshListIntervalInMinutes(
            config.AutoRefreshListIntervalInMinutes,
          );
          g.setInCountingBatchDisplayDetailMessage(
            config.InCountingBatchDisplayDetailMessage,
          );
          g.setLoadDraftAfterCreate(config.LoadDraftAfterCreate);
          g.setCustomDueDateLogic(config.CustomDueDateLogic);
          g.setItemDetailsFooterOnTop(config.ItemDetailsFooterOnTop);
          g.setIgnoreTriggerPricesInCopyTo(config.IgnoreTriggerPricesInCopyTo);
          g.setAllowShowAllInPriceHistory(config.AllowShowAllInPriceHistory);
          g.setShowUOMInPriceHistory(config.ShowUOMInPriceHistory);
          g.setInCountingNormalItemisplayDetailMessage(
            config.InCountingNormalItemisplayDetailMessage,
          );
          g.setInCountingNormalItemDisplayConfirmMessage(
            config.InCountingNormalItemDisplayConfirmMessage,
          );
          g.setInCountingDeleteNormalItemAllowChooseQty(
            config.InCountingDeleteNormalItemAllowChooseQty,
          );
          g.setInCountingDisableCumulativeModeForNormal(
            config.InCountingDisableCumulativeModeForNormal,
          );
          g.setCalcTotalAccordingToQty(config.CalcTotalAccordingToQty);
          g.setDisplayExpirationDateForBinBatchs(
            config.DisplayExpirationDateForBinBatchs,
          );
          g.setValidationBeforeCheckout(config.ValidationBeforeCheckout);
          g.setEnableItemImportation(config.EnableItemImportation);
          g.setBackToPackagePage(config.BackToPackagePage);
          g.setDisablePayingMultiDocument(config.DisablePayingMultiDocument);
          g.setDefaultWarehouseInATP(config.DefaultWarehouseInATP);
          g.setSpecialTextIsHTML(config.SpecialTextIsHTML);
          g.setAllowHTMLInText(config.AllowHTMLInText);
          g.setAllowBulkLineDelete(config.AllowBulkLineDelete);
          g.setAllowBulkLineCloseForModules(
            config.AllowBulkLineCloseForModules,
          );
          g.setExecuteCustomActionAfterCreateForModules(
            config.ExecuteCustomActionAfterCreateForModules,
          );
          g.setExecuteCustomActionAfterUpdateForModules(
            config.ExecuteCustomActionAfterUpdateForModules,
          );
          g.setRemoveActionTextForModules(config.RemoveActionTextForModules);
          g.setShowSpinnerWhenAddingBOM(config.ShowSpinnerWhenAddingBOM);
          g.setShowSupplierSSCCNumberField(config.ShowSupplierSSCCNumberField);
          g.setShowMnfSerialField(config.ShowMnfSerialField);
          g.setCopyBatchNumberToMnfSerial(config.CopyBatchNumberToMnfSerial);
          g.setShowAcceptanceOnlinePaymentMsg(
            config.ShowAcceptanceOnlinePaymentMsg,
          );
          g.setAcceptanceOnlinePaymentMsg(config.AcceptanceOnlinePaymentMsg);
          g.setLookForBatchInBaseForReturn(config.LookForBatchInBaseForReturn);
          g.setSC_SaveAsDraftAlwaysEP(config.SC_SaveAsDraftAlwaysEP);
          g.setSC_SaveAsDraftAlwaysCP(config.SC_SaveAsDraftAlwaysCP);
          g.setSC_SaveCartDirectlyEP(config.SC_SaveCartDirectlyEP);
          g.setSC_SaveCartDirectlyCP(config.SC_SaveCartDirectlyCP);
          g.setSC_HideNavigationEP(config.SC_HideNavigationEP);
          g.setSC_HideNavigationCP(config.SC_HideNavigationCP);
          g.setAllowBulkEdit(config.AllowBulkEdit);
          g.setEnableAnnouncement(config.EnableAnnouncement);
          g.setHeaderHtmlQueryId(config.HeaderHtmlQueryId);
          g.setTicketConversationIsOpen(config.TicketConversationIsOpen);
          g.setCheckDatesBeforeAddLinesToOrder(
            config.CheckDatesBeforeAddLinesToOrder,
          );
          g.setDontDisplayNotificationForNewItem(
            config.DONTDisplayNotificationForNewItem,
          );
          g.setUniqueBatchModeCounting(config.UniqueBatchModeCounting);
          g.setAutoDisplayDeliverSchedule(config.AutoDisplayDeliverSchedule);
          g.setAutoDisplayDeliverScheduleForQuantity(
            config.AutoDisplayDeliverScheduleForQuantity,
          );
          g.setAutoDisplayDeliverScheduleForShipDate(
            config.AutoDisplayDeliverScheduleForShipDate,
          );
          g.setAllowAddNewItemsInPackage(config.AllowAddNewItemsInPackage);
          g.setAllowAddNewLinesInMiddle(config.AllowAddNewLinesInMiddle);
          g.setAllowModifyUOMInSC(config.AllowModifyUOMInSC);
          g.setCheckUOMInSC(config.CheckUOMInSC);
          g.setAllowModifyWHSInSC(config.AllowModifyWHSInSC);
          g.setMessageWhenChoosingBPQueryId(
            config.MessageWhenChoosingBPQueryId,
          );
          g.setAutoScanQtyForSTQueryId(config.AutoScanQtyForSTQueryId);
          g.setPaymentFeeValuesQueryId(config.PaymentFeeValuesQueryId);
          g.setAvailableWHSForItemQryId(config.AvailableWHSForItemQryId);
          g.setATPWHSListQryId(config.ATPWHSListQryId);
          g.setMessageWhenEditingOrderQueryId(
            config.MessageWhenEditingOrderQueryId,
          );
          g.setFeasibilityModuleID(config.FeasibilityModuleID);
          g.setFeasibilitySpeedQryID(config.FeasibilitySpeedQryID);
          g.setFeasibilitySLAQryID(config.FeasibilitySLAQryID);
          g.setFeasibilityTermQryID(config.FeasibilityTermQryID);
          g.setFeasibilityLayoutID(config.FeasibilityLayoutID);
          g.setSC_DocumentLayoutID(config.SC_DocumentLayoutID);
          g.setFeasibilityDocType(config.FeasibilityDocType);
          g.setCheckItemsInBaseDocumentQueryId(
            config.CheckItemsInBaseDocumentQueryId,
          );
          g.setAutoDisplayDeliverScheduleForOnHand(
            config.AutoDisplayDeliverScheduleForOnHand,
          );
          g.setTriggerDeliverScheduleForShipDate(
            config.TriggerDeliverScheduleForShipDate,
          );
          g.setDeliveryScheduleBypassField(config.DeliveryScheduleBypassField);
          g.setDeliveryScheduleBypassHeaderDateField(
            config.DeliveryScheduleBypassHeaderDateField,
          );
          g.setUniqueBatchModeGoodIssue(config.UniqueBatchModeGoodIssue);
          g.setSetSumAppliedInCash(config.SetSumAppliedInCash);
          g.setEnableReverseMode(config.EnableReverseMode);
          g.setPickListLoadDataLine(config.PickListLoadDataLine);
          g.setEnableAutoIncreaseMode(config.EnableAutoIncreaseMode);
          g.setAutoIncreaseActivatedByDef(config.AutoIncreaseActivatedByDef);
          g.setEnableMovingLineInUpdateMode(
            config.EnableMovingLineInUpdateMode,
          );
          g.setShowConfirmationForNormalItem(
            config.ShowConfirmationForNormalItem,
          );
          g.setCheckBaseTotalForDocuments(config.CheckBaseTotalForDocuments);
          g.setCheckItemsInBaseDocument(config.CheckItemsInBaseDocument);
          g.setCheckItemsInBaseDocumentForActions(
            config.CheckItemsInBaseDocumentForActions,
          );
          g.setShowConfirmationForNewBatch(config.ShowConfirmationForNewBatch);
          g.setChildPropertiesShouldMatchParent(
            config.ChildPropertiesShouldMatchParent,
          );
          g.setCheckPropertiesToIgnoreInCopyToForDocuments(
            config.CheckPropertiesToIgnoreInCopyToForDocuments,
          );
          g.setPropertiesToIgnoreInCopyTo(config.PropertiesToIgnoreInCopyTo);
          g.setCheckPropertiesToTriggerInDuplicateForDocuments(
            config.CheckPropertiesToTriggerInDuplicateForDocuments,
          );
          g.setCopyFromAddressForDocuments(config.CopyFromAddressForDocuments);
          g.setCheckPropertiesToTriggerInCopyToForDocuments(
            config.CheckPropertiesToTriggerInCopyToForDocuments,
          );
          g.setEnableItemFileImportationForDocuments(
            config.EnableItemFileImportationForDocuments,
          );
          g.setDefaultWarehouseInFileImportation(
            config.DefaultWarehouseInFileImportation,
          );
          g.setEnableScanPackageForModules(config.EnableScanPackageForModules);
          g.setDisableAddingNewLinesForDocuments(
            config.DisableAddingNewLinesForDocuments,
          );
          g.setEnableBatchAllocationForDocuments(
            config.EnableBatchAllocationForDocuments,
          );
          g.setSC_ExtraMessageForDraft(config.SC_ExtraMessageForDraft);
          g.setAllowExceedOpenQtyForDocuments(
            config.AllowExceedOpenQtyForDocuments,
          );
          g.setDeleteIsOutOfActionsFor(config.DeleteIsOutOfActionsFor);
          g.setIgnoreCheckApproveFor(config.IgnoreCheckApproveFor);
          g.setPNPCreationActionCode(config.PNPCreationActionCode);
          g.setPNPHideSplitStep(config.PNPHideSplitStep);
          g.setPropertiesToTriggerInDuplicate(
            config.PropertiesToTriggerInDuplicate,
          );
          g.setPropertiesToTriggerInCopyTo(config.PropertiesToTriggerInCopyTo);
          g.setNavigateToWebsites(config.NavigateToWebsites);
          g.setWithCredentials(config.HttpWithCredentials);
          g.setEnableDecisionControlsForAnyUser(
            config.EnableDecisionControlsForAnyUser,
          );
          g.setEnableCacheOnItemScanning(config.EnableCacheOnItemScanning);
          g.setUpdateQuantitiesForTemplateBOM(
            config.UpdateQuantitiesForTemplateBOM,
          );
          g.setForeignIsRateMultplication(config.ForeignIsRateMultplication);
          g.setUpdatePricesForSimilarItems(config.UpdatePricesForSimilarItems);
          g.setUpdateDiscountsForSimilarItems(
            config.UpdateDiscountsForSimilarItems,
          );
          g.setCopyNumAtCardWhenCopyFrom(config.CopyNumAtCardWhenCopyFrom);
          g.setPNP_HideCreateDeliveryBTN(config.PNP_HideCreateDeliveryBTN);
          g.setPNP_HideCreateStockTransferBTN(
            config.PNP_HideCreateStockTransferBTN,
          );
          g.setAdditionalFieldsCopyFromPOR(config.AdditionalFieldsCopyFromPOR);
          g.setAdditionalFieldsCopyFromPCH(config.AdditionalFieldsCopyFromPCH);
          g.setAdditionalFieldsCopyFromQUT(config.AdditionalFieldsCopyFromQUT);
          g.setSC_VariantOptions(config.SC_VariantOptions);
          g.setDisplayQuoteNameForQUT(config.DisplayQuoteNameForQUT);
          g.setDisplaySalesSourceForQUT(config.DisplaySalesSourceForQUT);
          g.setSalesSourceFilterQryId(config.SalesSourceFilterQryId);
          g.setPalletPkgDetailQryId(config.PalletPkgDetailQryId);
          g.setCheckPalletPkgQryId(config.CheckPalletPkgQryId);
          g.setCheckPkgQryId(config.CheckPkgQryId);
          g.setListOfSubjectsQryId(config.ListOfSubjectsQryId);
          g.setPalletPkgTemplate(config.PalletPkgTemplate);
          g.setFieldsTobeCopiedWhenCopyFrom(
            config.FieldsTobeCopiedWhenCopyFrom,
          );
          g.setOAT_FieldsTobeCopiedWhenCopyFromAddress(
            config.OAT_FieldsTobeCopiedWhenCopyFromAddress,
          );
          g.setFieldsTobeCopiedWhenCopyFromAddress(
            config.FieldsTobeCopiedWhenCopyFromAddress,
          );
          g.setFieldsTobeCopiedWhenCopyFromForCredit(
            config.FieldsTobeCopiedWhenCopyFromForCredit,
          );
          g.setAllowEditEvenWhenClose(config.AllowEditEvenWhenClose);
          g.setUomQueryParamFields(config.UomQueryParamFields);
          g.setAllowAddLinesEvenWhenClose(config.AllowAddLinesEvenWhenClose);
          g.setHideITMFromFooter(config.HideITMFromFooter);
          g.setSetDefaultDiscount(config.SetDefaultDiscount);
          g.setSetDefaultDiscountOnQtyChange(
            config.SetDefaultDiscountOnQtyChange,
          );
          g.setRedirectToEmployeeLogin(config.RedirectToEmployeeLogin);
          g.setDisplayLandingPageLink(config.DisplayLandingPageLink);
          g.setSSCCHidden(config.SSCCHidden);
          g.setHideDetailsButtonInCardsSection(
            config.HideDetailsButtonInCardsSection,
          );
          g.setHideDeleteButtonInCardsSection(
            config.HideDeleteButtonInCardsSection,
          );
          g.setEnableAddVariants(config.EnableAddVariants);
          g.setForceDisplayModeAsTable(config.ForceDisplayModeAsTable);
          g.setHideDisplayModeDropdown(config.HideDisplayModeDropdown);
          g.setGoToSourceList(config.GoToSourceList);
          g.setUseNZSelectInLines(config.UseNZSelectInLines);

          g.setShowSignaturePadTermsAndCondition(
            config.ShowSignaturePadTermsAndCondition,
          );
          g.setSignaturePadTermsAndConditionLink(
            config.SignaturePadTermsAndConditionLink,
          );
          g.setSignaturePadTermsAndConditionText(
            config.SignaturePadTermsAndConditionText,
          );
          g.setOverrideQuantityDecimals(config.OverrideQuantityDecimals);

          console.log('let language = localStorage.getItem');

          let language = localStorage.getItem('language');
          if (language === '' || language == null) {
            language = config.DefaultLanguage;
            g.setLanguage(language);
          } else {
            g.setLanguage(language);
          }

          if (language === 'fr') {
            import('@angular/common/locales/fr').then((lang) => {
              registerLocaleData(lang.default);

              import('ng-zorro-antd/i18n').then((d) => {
                this.nzI18nService.setLocale(d.fr_FR);
              });
            });
          } else if (language === 'es') {
            import('@angular/common/locales/es').then((lang) => {
              registerLocaleData(lang.default);

              import('ng-zorro-antd/i18n').then((d) => {
                this.nzI18nService.setLocale(d.es_ES);
              });
            });
          } else if (language === 'de') {
            import('@angular/common/locales/de').then((lang) => {
              registerLocaleData(lang.default);

              import('ng-zorro-antd/i18n').then((d) => {
                this.nzI18nService.setLocale(d.de_DE);
                console.log('x y z', d);
              });
            });
          } else if (language === 'ru') {
            import('@angular/common/locales/ru').then((lang) => {
              registerLocaleData(lang.default);

              import('ng-zorro-antd/i18n').then((d) => {
                this.nzI18nService.setLocale(d.ru_RU);
              });
            });
          } else if (language === 'it') {
            import('@angular/common/locales/it').then((lang) => {
              registerLocaleData(lang.default);

              import('ng-zorro-antd/i18n').then((d) => {
                this.nzI18nService.setLocale(d.it_IT);
              });
            });
          } else if (language === 'ar') {
            import('@angular/common/locales/ar').then((lang) => {
              registerLocaleData(lang.default);

              import('ng-zorro-antd/i18n').then((d) => {
                this.nzI18nService.setLocale(d.ar_EG);
              });
            });
          } else {
            import('@angular/common/locales/en').then((lang) => {
              registerLocaleData(lang.default);

              import('ng-zorro-antd/i18n').then((d) => {
                this.nzI18nService.setLocale(d.en_US);
              });
            });
          }

          console.log('after let language = localStorage.getItem');
          if (window.location !== window.parent.location) {
            console.log('window.location !== window.parent.location');
            resolve();
            return;
          }

          setTimeout(() => {
            this.sessionStorageService
              .getData(
                `${g.apiBaseUrl}Miscellaneous/GetTranslations?translateLanguage=${language}`,
              )
              .toPromise()
              .catch((d) => {
                g.setApplicationError(true);
                g.setApplicationErrorDetails(d);
                resolve();
              })
              .finally(() => {
                g.setApplicationInitiated(true);
              })
              .then((trans: any) => {
                if (trans === undefined) {
                  return;
                }

                const urlParams = new URLSearchParams(window.location.search);
                /*const ltParam = urlParams.get('lt');
                if (ltParam) {
                  if (!g.tokenInCookie) {
                    localStorage.setItem('token', ltParam);
                  } else {
                    document.cookie = `token=${ltParam}; path=/; max-age=3600; Secure; SameSite=Strict`;
                  }
                }*/

                const ltParam = urlParams.get('lt');

                if (ltParam) {
                  // Remove previous token from both locations
                  localStorage.removeItem('token');
                  document.cookie =
                    'token=; path=/; max-age=0; Secure; SameSite=Strict';

                  // Store the new token
                  if (g.tokenInCookie) {
                    document.cookie = `token=${encodeURIComponent(ltParam)}; path=/; max-age=3600; Secure; SameSite=Strict`;
                  } else {
                    localStorage.setItem('token', ltParam);
                  }
                } /*else {
                  // Do not reuse an old doctor's token
                  // Only appropriate if this page always requires a new lt parameter
                  localStorage.removeItem('token');
                  document.cookie =
                    'token=; path=/; max-age=0; Secure; SameSite=Strict';
                }*/

                g.setTranslationsData(trans.Translations);
                if (
                  this.activateRoute.snapshot.queryParams.token !== undefined &&
                  !fromOneTime
                ) {
                  console.log(
                    'this.activateRoute.snapshot.queryParams.token !== undefined',
                  );
                  resolve();
                } else if (g.getToken() !== null || g.oneTimeToken !== '') {
                  console.log('g.getToken() !== null || g.oneTimeToken !==');
                  this.authenticationService
                    .isTokenValid(appKey)
                    .then((token: { Success: boolean; Message: string }) => {
                      if (token.Success) {
                        this.http
                          .get(`${g.apiBaseUrl}data/GetData`)
                          .toPromise()
                          .then((d: any) => {
                            this.sessionStorageService
                              .getData(
                                `${g.apiBaseUrl}Layout/GetConfiguration?configCode=config_reverse_calculation`,
                              )
                              .subscribe((data) => {
                                if (data && data !== '') {
                                  Documents.reverseCalculation = data === 'Y';
                                }
                              });

                            this.sessionStorageService.clearDatabase();

                            g.setQueriesData(d.Queries);
                            g.setModulesData(d.ModuleData);
                            // g.setBWEBConfig(d.bwebConfig);
                            this.http
                              .get(
                                `${g.apiBaseUrl}data/GetCompanyConfiguration`,
                              )
                              .toPromise()
                              .then((companyConfiguration: any) => {
                                g.setCompanyConfiguration(companyConfiguration);

                                this.http
                                  .get(`${g.apiBaseUrl}data/Tax`)
                                  .toPromise()
                                  .then((tax: any) => {
                                    g.setTaxes(tax);

                                    this.http
                                      .get(
                                        `${g.apiBaseUrl}data/GetSessionValues`,
                                      )
                                      .toPromise()
                                      .then((sessionValues: any) => {
                                        g.setSessionValues(sessionValues);
                                        resolve();
                                        /*this.http
                                        .get(
                                          `${g.apiBaseUrl
                                          }data/GetCurrencies`
                                        )
                                        .toPromise()
                                        .then((currencies: any) => {
                                          g.setCurrencies(currencies);

                                          resolve();
                                        });*/
                                      });
                                  });
                              });
                          });
                      } else {
                        this.authenticationService.logout().subscribe(() => {
                          resolve();
                          this.router.navigate(['/']);
                        });
                      }
                    });
                } else {
                  resolve();
                }
              });
          }, 1500);
        });
    });
  }
}
